import { httpCreate } from './http';

const http = httpCreate('/shop/api/activity-blind-box-group');

export const activityBlindBoxGroup = {
	/**
	 * @param { Number } boxId
	 * @param { String } data.name  盲盒组名称
	 * @param { String } data.banner    图片
	 * @param { String } data.price 价格。单位分
	 * @param { Array } data.proList
	 * @param { Number } proList[index].proId   商品id
	 * @param { Number } proList[index].totalStockNumber    库存
	 * @param { String } proList[index].hintWords   提示语
	 */
	save(boxId, data) {
		return http.post(`/${boxId}`, data);
	},
	/**
	 * @param { Number } boxId
	 * @param { String } data.name  盲盒组名称
	 * @param { String } data.banner    图片
	 * @param { String } data.price 价格。单位分
	 * @param { Array } data.proList
	 * @param { Number } proList[index].id   id 存在一定传，用来判断增改
	 * @param { Number } proList[index].proId   商品id
	 * @param { Number } proList[index].totalStockNumber    库存
	 * @param { String } proList[index].hintWords   提示语
	 */
	edit(boxId, groupId, data) {
		return http.put(`/${boxId}/update/${groupId}`, data);
	},
	// 获取盲盒组信息
	getGroupInfo(groupId, params) {
		return http.get(`/one/${groupId}`, { params });
	},
	// 获取盲盒组列表
	nameList(boxId, params) {
		return http.get(`/nameList/${boxId}`, { params });
	},
	// 删除盲盒组
	deleteGroup(groupId) {
		return http.delete(`${groupId}`);
	},
};
